module.exports = __webpack_public_path__ + "img/notification.58a77840.svg";